
    <input class="input is-fullwidth" type="text" placeholder="Your response">
   